/**
 * Blog archive — AJAX category filtering + AJAX pagination.
 * Localised data (ajax url + nonce) comes from `DYK_BLOG` (wp_localize_script).
 */
export default function blogFilter() {
  const grid = document.getElementById('blogPosts');
  const pag = document.getElementById('blogPagination');
  const filters = document.getElementById('blogFilters');
  if (!grid || !filters || typeof window.DYK_BLOG === 'undefined') return;

  let currentCat = '';
  let busy = false;

  async function load(cat, paged) {
    if (busy) return;
    busy = true;
    grid.classList.add('is-loading');

    try {
      const body = new URLSearchParams({
        action: 'dykyiivan_blog_filter',
        cat,
        paged,
        nonce: window.DYK_BLOG.nonce,
      });
      const res = await fetch(window.DYK_BLOG.ajax, { method: 'POST', body });
      const json = await res.json();
      if (json && json.success) {
        grid.innerHTML = json.data.cards;
        if (pag) pag.innerHTML = json.data.pagination;
      }
    } catch (e) {
      /* silent */
    } finally {
      grid.classList.remove('is-loading');
      busy = false;
    }
  }

  // filter tags
  filters.addEventListener('click', (e) => {
    const btn = e.target.closest('.filter-tag');
    if (!btn) return;
    e.preventDefault();
    filters.querySelectorAll('.filter-tag').forEach((t) => t.classList.remove('active'));
    btn.classList.add('active');
    currentCat = btn.dataset.cat || '';
    load(currentCat, 1);
  });

  // pagination (delegated)
  if (pag) {
    pag.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-page]');
      if (!btn) return;
      e.preventDefault();
      load(currentCat, parseInt(btn.dataset.page, 10) || 1);
      const top = grid.getBoundingClientRect().top + window.scrollY - 120;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  }
}
